import { useEffect, useState } from "react"
import { isUndefined } from "lodash"
import IconToggleArrowRight from "assets/images/icons/icon-toggle-arrow-right.svg"

import { DownloadQueueItem } from "./downloadQueue"
import { ProcessItemCard } from "./ProcessItemCard"

interface Props {
  queues: DownloadQueueItem[]
  progress?: number
  downloadId?: string
  callBack: (type: "delete", downloadId) => Promise<void>
}

export const DownLoadProcessCard = ({
  queues,
  downloadId,
  progress,
  callBack,
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [localProgress, setLocalProgress] = useState<Record<string, number>>({})
  useEffect(() => {
    if (!isUndefined(progress) && downloadId) {
      setLocalProgress((prev) => {
        const currentProgress = prev[downloadId] ?? 0
        if (progress >= currentProgress) {
          return {
            ...prev,
            [downloadId]: progress,
          }
        }
        return prev
      })
    }
  }, [progress, downloadId])

  const renderQueueItem = (queue: DownloadQueueItem, index: number) => {
    return (
      <ProcessItemCard
        queue={queue}
        key={queue.downloadId}
        index={index}
        totalQueues={queues.length}
        callBack={callBack}
        currentProgress={
          queue.downloadId && localProgress[queue.downloadId]
            ? localProgress[queue.downloadId]
            : 0
        }
      />
    )
  }
  return (
    <div className="flex flex-col ">
      <div
        className="flex items-center px-3 justify-between min-h-[44px] min-w-[350px] max-w-[400px] bg-[#FDBE44]"
        style={{
          borderBottom: !isExpanded ? "1px solid #E4E4E4" : "none",
        }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <p className="font-semibold text-[14px] leading-[24px] text-[#111111]">
          In progress
        </p>
        <img
          src={IconToggleArrowRight}
          alt="toggle icon"
          style={{
            transform: !isExpanded ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </div>
      <div
        className={`transition-all duration-300 ease-in-out overflow-auto px-[12px] min-w-[350px] max-w-[400px] ${
          isExpanded ? "max-h-0 opacity-0" : "max-h-[500px] opacity-100"
        }`}
      >
        {queues.length ? (
          queues.filter((el) => !el.done).map(renderQueueItem)
        ) : (
          <div className="flex flex-col justify-center min-h-[48px]">
            <div className="flex items-center justify-center">
              <p className="text-[14px] italic leading-[24px] text-[#7a7a7a]">
                No download in progress
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
